import styles from './styles.module.css';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaPhone, FaEnvelope } from "react-icons/fa6";

import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { toastOptions } from 'src/constants/toast';
import { isRTL } from 'src/utils/global';




const Footer = () => {
    const { t } = useTranslation(['common']);

    const Links = [
        {
            name: t("footer.links.about"),
            to: "/about"
        },
        {
            name: t("footer.links.services"),
            to: "/services"
        },
        {
            name: t("footer.links.contact"),
            to: "/contact"
        },
        {
            name: t("footer.links.privacy"),
            to: "/privacy"
        }
    ];

    const copyToClipBoard = async (copyMe: string) => {
        try {
            await navigator.clipboard.writeText(copyMe);
            return true;
        } catch (err) {
            return false;
        }
    };

    const phoneCopyHandler = async (phoneNumber: string) => {
        const copied = await copyToClipBoard(phoneNumber);
        if (copied) {
            toast(t("footer.copied"), toastOptions);
        } else {
            console.log(t("footer.copy_error"));
        }
    };

    return (
        <section className={`${styles.footer} ${isRTL() && styles.rtl}`}>
            <div className="container">
                <div className={"row"}>
                    <div className='col-lg-4 col-12 mb-5 mb-lg-0'>
                        <div className={styles.location}>
                            <h4 className={styles.title}>{t("footer.location")}</h4>
                            <div>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3353.129226641254!2d12.980548299999999!3d32.8153408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13a8e7046d29ab65%3A0xc968096befc9059!2z2LTYsdmD2Kkg2KfZhtiq2LXYp9ixINin2YTYstin2YfYsQ!5e0!3m2!1sar!2sly!4v1733428171879!5m2!1sar!2sly"

                                    height="227"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title={t("footer.map_title")}
                                ></iframe>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-12  mb-5 mb-lg-0'>

                        <div className={styles.list}>
                            <h4 className={styles.title}>{t("footer.links.title")}</h4>
                            <ul>
                                {Links.map((item, index) => (
                                    <li key={`links-key-${index}`}>
                                        <Link className={styles.link} to={item.to}>
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className='col-12 col-lg-4 col-md-6  mb-5 mb-lg-0'>
                        <div className={styles.list}>
                            <h4 className={styles.title}>
                                {t("footer.contact_info")}
                                <div className="underline">
                                    <div></div>
                                </div>
                            </h4>
                            <ul>
                                <li>
                                    <div className={styles.subTitle}>
                                        {t("footer.admin.title")}
                                    </div>
                                    <span className={styles.link} onClick={() => phoneCopyHandler("+218920475200")}>
                                        {t("footer.admin.phone1")}
                                    </span>

                                </li>
                                <li>
                                    <div className={styles.subTitle}>
                                        {t("footer.workshop.title")}
                                    </div>
                                    <span className={styles.link} onClick={() => phoneCopyHandler("+218912737825")}>
                                        {t("footer.workshop.phone1")}
                                    </span>

                                </li>
                                <li>
                                    <div className={styles.subTitle}>
                                        {t("footer.sales.title")}
                                    </div>
                                    <span className={styles.link} onClick={() => phoneCopyHandler("+218910446856")}>
                                        {t("footer.sales.phone1")}
                                    </span>
                                    <span className={styles.link} onClick={() => phoneCopyHandler("+218930495856")}>
                                        {t("footer.sales.phone2")}
                                    </span>
                                </li>

                            </ul>
                        </div>
                    </div>


                </div>
                <div className={styles.copyright}>
                    <div className={styles.icons}>
                        <a className={styles.icon} href="mailto:info@diknaitalia.com">
                            <div>
                                <FaEnvelope />
                            </div>

                        </a>
                        <a className={styles.icon} href="https://www.facebook.com/ELENTISAR">
                            <div>
                                <FaFacebookF />
                            </div>
                        </a>
                    </div>
                    <div>{t("footer.copyright")}</div>
                </div>
            </div>
        </section>
    );
};

export default Footer;
